import { UpdateInvoiceTransactionBodyParamAttributesInvoiceKind } from 'ap-openapi';

export const InvoiceKind =
  UpdateInvoiceTransactionBodyParamAttributesInvoiceKind;
export type InvoiceKind =
  UpdateInvoiceTransactionBodyParamAttributesInvoiceKind;

export const InvoiceKindCategory = {
  target: 'target',
  not_target: 'not_target',
  none: 'none',
} as const;

export type InvoiceKindCategory =
  (typeof InvoiceKindCategory)[keyof typeof InvoiceKindCategory];

export const getInvoiceKindCategory = (
  invoiceKindEnum: string | undefined
): InvoiceKindCategory => {
  if (invoiceKindEnum === undefined || invoiceKindEnum === '')
    return InvoiceKindCategory.none;
  else if (invoiceKindEnum === InvoiceKind.not_target) {
    return InvoiceKindCategory.not_target;
  } else {
    return InvoiceKindCategory.target;
  }
};

export const invoiceKindEnumToI18nLabel = (
  t: (key: string) => string,
  invoiceKindEnum: string | undefined
): string => {
  if (invoiceKindEnum === undefined || invoiceKindEnum === '') return '';
  return t(`invoice_kind.${invoiceKindEnum}`);
};

export const invoiceKindI18nLabelToEnum = (
  t: (key: string) => string,
  invoiceKindI18nLabel: string | undefined
): string => {
  if (invoiceKindI18nLabel === undefined || invoiceKindI18nLabel === '')
    return '';
  const match = Object.values(InvoiceKind).find(
    (key) => t(`invoice_kind.${key}`) === invoiceKindI18nLabel
  );
  return match ?? '';
};
